import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    /* Mobile rows: subheader / media / header / description / CTA. */
    .tyler-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .subheader {
      /* Pinned small at all widths; the bare-p default would grow to 16px
         on desktop. */
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .primary-text {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    /* Closes the text stack rather than sitting beside the subheader
       (Figma 22166:4039); the row gap carries part of the 40px. */
    .cta-btn {
      grid-column: 2 / 8;
      grid-row: 6;
      margin-top: calc(var(--text-stack-cta-gap) - var(--block-row-gap));
    }

    .image {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .image img {
      width: 100%;
    }

    .video {
      grid-column: 2 / 8;
      grid-row: 3;
      width: 100%;
      position: relative;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    @media (min-width: 600px) {
      /* Match the image-caption progression: caption on mobile, body-small
         on desktop. */
      .image-description > span > p {
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
      }

      .tyler-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .details-row {
        margin-bottom: var(--top-padding-height);
      }

      /* Opens the right-hand text column. The 5px lands the header's first
         baseline 40px below the subheader's, as the mock has it. */
      .subheader {
        grid-column: 9 / 14;
        grid-row: 2;
        margin-bottom: calc(5rem / var(--default-rem-px-count));
      }

      .primary-text {
        grid-column: 9 / 14;
        grid-row: 3;
      }

      .description {
        grid-column: 9 / 13;
        grid-row: 4;
      }

      .cta-btn {
        grid-column: 9 / 14;
        grid-row: 5;
        place-self: self-end left;
        padding-bottom: calc(6rem / var(--default-rem-px-count));
        margin-top: 0;
      }

      /* Rows 3-5 only: spanning row 2 as well would let the media's height
         inflate the subheader's row and push the header away from it. */
      .video,
      .image {
        grid-column: 2 / 9;
        grid-row: 3 / 6;
      }
    }

    @media (min-width: 1200px) {
      .primary-text {
        grid-column: 9 / 13;
      }
    }
  `,
];
